import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const StrengthConcernsSection = ({
  sessionFormData,
  updateFormData,
  handleStrengthsChange,
  strengthsError,
  autoResizeTextarea
}) => {
  const strengthsOptions = [
    "Supportive relationships",
    "Community involvement",
    "Coping skills",
    "Other",
    "Employment stability",
    "Faith/spirituality",
    "Resilience"
  ];

  const leftColumnItems = strengthsOptions.slice(0, Math.ceil(strengthsOptions.length / 2));
  const rightColumnItems = strengthsOptions.slice(Math.ceil(strengthsOptions.length / 2));

  return (
    <Card id="strength-resources" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Strengths & Resources
      </h3>

      <div style={{ marginBottom: "24px" }}>
        <label className={styles.labelWithMarginXLarge}>
          Select all that apply:
        </label>
        {strengthsError && (
          <div className={styles.errorMessage} style={{ marginTop: "8px", marginBottom: "12px" }}>
            {strengthsError}
          </div>
        )}
        <div className={styles.checkboxRow}>
          {/* Left Column */}
          <div className={styles.checkboxColumn}>
            {leftColumnItems.map((item) => {
              const isOtherOption = item === "Other";
              return (
                <div key={item} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`strength-${item}`}
                    checked={sessionFormData.selectedStrengths.includes(item)}
                    onChange={() => handleStrengthsChange(item)}
                    className={styles.checkbox}
                  />
                  <label htmlFor={`strength-${item}`} className={styles.checkboxLabel}>
                    {item}
                  </label>
                </div>
              );
            })}
          </div>
          <div className={styles.checkboxColumn}>
            {rightColumnItems.map((item) => (
              <div key={item} className={styles.checkboxContainer}>
                <input
                  type="checkbox"
                  id={`strength-${item}`}
                  checked={sessionFormData.selectedStrengths.includes(item)}
                  onChange={() => handleStrengthsChange(item)}
                  className={styles.checkbox}
                />
                <label htmlFor={`strength-${item}`} className={styles.checkboxLabel}>
                  {item}
                </label>
              </div>
            ))}
          </div>
        </div>
        {sessionFormData.selectedStrengths.includes("Other") && (
          <div style={{ marginTop: "12px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px", marginBottom: "4px" }}>
              <div style={{ fontSize: "12px", color: "#8E8E93", whiteSpace: "nowrap" }}>
                {sessionFormData.otherStrengthsText?.length || 0}/100
              </div>
            </div>
            <textarea
              id="other-Strength-Text"
              value={sessionFormData.otherStrengthsText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherStrengthsText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
              maxLength={100}
            />
          </div>
        )}
      </div>

      <div style={{ marginTop: "24px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <label className={styles.labelWithMargin}>
            Client's own description of strengths
          </label>
          <div style={{ marginTop: "4px", fontSize: "12px", color: "#8E8E93" }}>
            {sessionFormData.clientStrengthsDescription?.length || 0}/400
          </div>
        </div>
        <textarea
          value={sessionFormData.clientStrengthsDescription || ""}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 400) {
              updateFormData("clientStrengthsDescription", value);
            }
          }}
          placeholder="Free Text"
          className={styles.textarea}
          maxLength={400}
        />
      </div>
    </Card>
  );
};

export default StrengthConcernsSection;

